(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('AgentCategoryAccessDeleteController', AgentCategoryAccessDeleteController);

    AgentCategoryAccessDeleteController.$inject = ['$uibModalInstance', 'entity', 'AgentCategoryAccess'];

    function AgentCategoryAccessDeleteController($uibModalInstance, entity, AgentCategoryAccess) {
        var vm = this;

        vm.agentCategoryAccess = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            AgentCategoryAccess.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
